import React, { useEffect, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import ButtonEdit from "../../../assets/img/icons/ButtonEdit.svg";
import DeleteIcon from "../../../assets/img/icons/deleteIcon.svg";
import Card from "components/card";
import {
  Button,
  Center,
  ChakraProvider,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import { getProjDeptDesig, updateProjDeptDesig } from "services/customAPI";
import Navbar from "components/navbar";
import { toast } from "react-toastify";
import customAxios from "services/appservices";
import XLSX from "sheetjs-style";
import * as FS from "file-saver";
import sampleFile from "./sampleFile/bulkDataUpload.xlsx";
import { useSelector } from "react-redux";
import { Box, Text, UnorderedList, ListItem } from "@chakra-ui/react";

const UserForm: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const project = useSelector((store: any) => store.auth.project);
  const user = useSelector((store: any) => store.auth.user);
  const [projectData, setProjectData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [editIndex, setEditIndex] = useState(-1); // State to track the index of the item being edited
  //?
  const [field, setField] = useState("");
  const [element, setElement] = useState("");
  const [action, setActions] = useState("");
  const [editedData, setEditedData] = useState<string>("");
  const [isFocused, setIsFouced] = useState(false);
  //?

  const loadData = async () => {
    setIsLoading(true)
    try {
       const res: any = await getProjDeptDesig();
       console.log({ res });
       if (res && res[0]) {
         const { projects, designations, departments } = res[0];
         projects && setProjectData(projects);
         designations && setDepartmentData(departments);
         departments && setDesignationData(designations);
       }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log("Error",error)
    }
   
  };
   const updateData = async (
     type: string,
     oldVal: string,
     action: string,
     newVal?: string
   ) => {
        setIsLoading(true);
        if ((action == "edit" && newVal == "") || !field) {
          errorToast("Enter Data !1");
          return;
        } else if (action == "addData" && editedData == "") {
          errorToast("Enter Data !2");
          return;
        }
        onClose();
        const ress: any = await updateProjDeptDesig(
          type,
          oldVal,
          newVal,
          action
        );
        if (ress.message) {
          successToast(ress.message);
        } else {
          errorToast("Something went wrong !");
        }
        console.log({ ress });
        loadData();
     try {
      
     } catch (error) {
      setIsLoading(false)
     }
  
   };
  useEffect(() => {
    loadData();
  }, []);

  const handleClick = (index: any, field: string) => {
    console.log({ field });
    setField(field);
    setEditIndex(index); // Set the index of the item being edited
    field == "projects"
      ? setEditedData(projectData[index])
      : field == "departments"
      ? setEditedData(departmentData[index])
      : setEditedData(designationData[index]);
  };
 
  const [isLoading, setIsLoading] = useState(false);

  const successToast = (message: string) => {
    toast.success(`${message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { borderRadius: "15px" },
    });
  };

  const errorToast = (message: string) => {
    toast.error(`${message}`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { borderRadius: "15px" },
    });
  };

  const uploadFailedToast = (message: string) => {
    toast.error(`${message}`, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { borderRadius: "15px", whiteSpace: "pre-line" },
    });
  };

  const [csvModal, setCsvModal] = useState(false);
  const [file, setFile] = useState(null);
  interface MyData {
    _id: object;
    __v: number;
    updatedAt: Date;
    createdAt: Date;
    role: string;
  }
  const submitFile = async () => {
    if (!file) {
      errorToast("Please select a file");
    } else {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("file", file);
      const res: MyData[] = await customAxios.post(
        "/users/uploadUtilsDetails",
        formData
      );
      console.log({ res });
      if (res) {
        setIsLoading(false);
        successToast("Data Uploaded successfully");
      } else {
        setIsLoading(false);
        uploadFailedToast(
          "Some data not uploaded \nPlease check downloaded file"
        );
        let filetype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetchareset-UTF-8";
        const filteredDataArray = res.map(
          ({ _id, __v, updatedAt, createdAt, role, ...rest }) => rest
        );
        const ws = XLSX.utils.json_to_sheet([...filteredDataArray]);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelb = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelb], { type: filetype });
        FS.saveAs(data, "FaildUsersUpload.xlsx");
      }
    }
  };

  const handleInputChange = (e: any, index?: any) => {
    setEditedData(e);
  };

  return (
    <>
      <Navbar flag={false} brandText="driverform" />

      {isLoading ? (
        <div className="flex min-h-screen items-center justify-center">
          <ChakraProvider>
            <Spinner
              thickness="4px"
              speed="0.999s"
              emptyColor="gray.200"
              color="green.500"
              size="xl"
            />
          </ChakraProvider>
        </div>
      ) : (
        <Card extra={"w-full pb-6 p-4 mt-4 pt-10"}>
          <header>
            <div className="relative flex items-center justify-between">
              <div className="text-2xl font-bold text-navy-700 dark:text-white">
                Add Utils
              </div>
              <div>
                {
                  <div>
                    {csvModal ? (
                      <Button
                        type="submit"
                        className="mr-2 rounded-md bg-brand-500 p-2 text-white dark:bg-brand-400"
                        onClick={() =>
                          FS.saveAs(sampleFile, "BulkDataUpload.xlsx")
                        }
                      >
                        Download Sample File
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        className="rounded-md bg-blue-600 p-2 text-white dark:bg-brand-400"
                        // onClick={() => setCsvModal(true)}
                        onClick={() => {
                          onOpen();
                          setElement("");
                          setEditedData("");
                          setActions("addData");
                          setField("");
                        }}
                      >
                        Add Data
                      </Button>
                    )}
                  </div>
                }
              </div>
            </div>
          </header>
          {!csvModal ? (
            <>
              <Flex
                onClick={() => setIsFouced(false)}
                flexDirection="row"
                alignItems="center"
                flex={1}
                className="mb-2 mt-6 bg-gray-100 dark:bg-blue-800 "
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Center flex={1}>
                  <Text fontWeight="bold" fontSize="lg" className="mb-2 mt-2">
                    Projects
                  </Text>
                </Center>

                <Center flex={1}>
                  <Text fontWeight="bold" fontSize="lg" className="mb-2 mt-2">
                    Departments
                  </Text>
                </Center>

                <Center flex={1}>
                  <Text fontWeight="bold" fontSize="lg" className="mb-2 mt-2">
                    Designations
                  </Text>
                </Center>
              </Flex>

              {projectData.length > 0 || departmentData.length>0 || designationData.length>0 ? (
                <>
                  <Flex
                    className="dark:text-white"
                    flexDirection="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                  >
                    {/* Projects */}
                    <Box
                      overflowY="auto"
                      height="65vh"
                      flex={1}
                      alignItems="flex-start"
                    >
                      <UnorderedList listStyleType="none">
                        {projectData.map((element, index) => (
                          <>
                            <ListItem
                              key={index}
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              {/* Render input field if index matches editIndex, otherwise render text */}
                              {editIndex === index &&
                              isFocused &&
                              field == "projects" ? (
                                <Box
                                  // flex="1"
                                  maxWidth="30rem"
                                  overflowX="hidden"
                                  // display="flex"
                                  flexDirection="row"
                                  alignItems="center"
                                >
                                  <Input
                                    className="ml-0.5 pl-1 pr-1 dark:bg-[#1d2955]"
                                    placeholder={element}
                                    value={editedData}
                                    onFocus={() => {
                                      setEditIndex(index);
                                      setIsFouced(true);
                                    }}
                                    onChange={(e) =>
                                      handleInputChange(e.target.value, index)
                                    }
                                    autoFocus // Focus input field on mount
                                    // onBlur={() => setEditIndex(-1)} // Save edited project name on blur
                                  />
                                  {editIndex === index && (
                                    <Button
                                      className="text-s ml-1.5 rounded-md  border-2 border-solid border-brand-500 !bg-brand-100 pb-0.5 pl-1 pr-1 pt-0.5 dark:!border-brandLinear  dark:!bg-blueSecondary"
                                      position={"sticky"}
                                      onClick={() => {
                                        setIsFouced(false);
                                        if (
                                          element.trim() != editedData.trim()
                                        ) {
                                          setEditIndex(-1);
                                          setElement(element);
                                          setActions("edit");
                                          setField("projects");
                                          onOpen();
                                        }
                                      }}
                                    >
                                      Update
                                    </Button>
                                  )}
                                </Box>
                              ) : (
                                <Box flex="1" maxWidth="200px">
                                  {element}
                                </Box>
                              )}

                              {/* Icons */}
                              <Flex className="mr-2">
                                <img
                                  src={ButtonEdit}
                                  className="button-edit me-2 cursor-pointer"
                                  height={30}
                                  width={30}
                                  onClick={() => {
                                    handleClick(index, "projects");
                                    setIsFouced(!isFocused);
                                  }}
                                />
                                <img
                                  src={DeleteIcon}
                                  className="button-edit me-2 cursor-pointer"
                                  height={30}
                                  width={30}
                                  onClick={() => {
                                    setElement(element);
                                    setActions("delete");
                                    setField("projects");
                                    onOpen();
                                  }}
                                />
                              </Flex>
                            </ListItem>
                            <div className="border-1 mb-1 mt-1 border-b border-solid border-blue-300"></div>
                          </>
                        ))}
                      </UnorderedList>
                    </Box>

                    {/* //?Departments */}
                    <Box
                      className="scrollbar-thin scrollbar-thumb-lightgreen scrollbar-auto"
                      overflowY="auto"
                      height="65vh"
                      flex={1}
                      alignItems="flex-start"
                    >
                      <UnorderedList listStyleType="none">
                        {departmentData.map((element, index) => (
                          <>
                            <ListItem
                              key={index}
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              {/* Render input field if index matches editIndex, otherwise render text */}
                              {editIndex === index &&
                              isFocused &&
                              field == "departments" ? (
                                <Box
                                  maxWidth="30rem"
                                  overflowX="hidden"
                                  // display="flex"
                                  flexDirection="row"
                                  alignItems="center"
                                >
                                  <Input
                                    className=" ml-0.5 pl-1 pr-1 dark:bg-[#1d2955]"
                                    placeholder={element}
                                    value={editedData}
                                    // onBlur={() => {
                                    //   setTimeout(() => {
                                    //     setIsFouced(false);
                                    //   }, 100);
                                    // }}
                                    onFocus={() => {
                                      setEditIndex(index);
                                      setIsFouced(true);
                                    }}
                                    onChange={(e) =>
                                      handleInputChange(e.target.value, index)
                                    }
                                    autoFocus // Focus input field on mount
                                    // onBlur={() => setEditIndex(-1)} // Save edited project name on blur
                                  />
                                  {editIndex === index && (
                                    <Button
                                      className="text-s ml-1.5 rounded-md  border-2 border-solid border-brand-500 !bg-brand-100 pb-0.5 pl-1 pr-1 pt-0.5 dark:!border-brandLinear  dark:!bg-blueSecondary"
                                      position={"sticky"}
                                      onClick={() => {
                                        setIsFouced(false);
                                        if (
                                          element.trim() != editedData.trim()
                                        ) {
                                          setEditIndex(-1);
                                          setElement(element);
                                          setActions("edit");
                                          setField("departments");
                                          onOpen();
                                        }
                                      }}
                                    >
                                      Update
                                    </Button>
                                  )}
                                </Box>
                              ) : (
                                <Box flex="1" maxWidth="200px">
                                  {element}
                                </Box>
                              )}

                              {/* Icons */}
                              <Flex className="mr-2">
                                <img
                                  src={ButtonEdit}
                                  className="button-edit me-2 cursor-pointer"
                                  height={30}
                                  width={30}
                                  onClick={() => {
                                    handleClick(index, "departments");
                                    setIsFouced(!isFocused);
                                  }}
                                />
                                <img
                                  src={DeleteIcon}
                                  className="button-edit me-2 cursor-pointer"
                                  height={30}
                                  width={30}
                                  onClick={() => {
                                    setElement(element);
                                    setActions("delete");
                                    setField("departments");
                                    onOpen();
                                  }}
                                />
                              </Flex>
                            </ListItem>
                            <div className="border-1 mb-1 mt-1 border-b border-solid border-blue-300"></div>
                          </>
                        ))}
                      </UnorderedList>
                    </Box>
                    {/* Designations */}
                    <Box
                      overflowY="auto"
                      height="65vh"
                      flex={1}
                      alignItems="flex-start"
                    >
                      <UnorderedList listStyleType="none">
                        {designationData.map((element, index) => (
                          <>
                            <ListItem
                              key={index}
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              {/* Render input field if index matches editIndex, otherwise render text */}
                              {editIndex === index &&
                              isFocused &&
                              field == "designations" ? (
                                <Box
                                  width="auto"
                                  // maxWidth="8rem"
                                  overflowX="hidden"
                                  // display="flex"
                                  flexDirection="row"
                                  alignItems="center"
                                >
                                  <Input
                                    className="ml-0.5 pl-1 pr-1 dark:bg-[#1d2955] "
                                    placeholder={element}
                                    value={editedData}
                                    // onBlur={() => {
                                    //   setTimeout(() => {
                                    //     setIsFouced(false);
                                    //   }, 100);
                                    // }}
                                    onFocus={() => {
                                      setEditIndex(index);
                                      setIsFouced(true);
                                    }}
                                    onChange={(e) =>
                                      handleInputChange(e.target.value, index)
                                    }
                                    autoFocus // Focus input field on mount
                                    // onBlur={() => setEditIndex(-1)} // Save edited project name on blur
                                  />
                                  {editIndex === index && (
                                    <Button
                                      className="ml-1.5 rounded-md border-2  border-solid border-brand-500 !bg-brand-100 pb-0.5 pl-1 pr-1 pt-0.5 text-xs dark:!border-brandLinear  dark:!bg-blueSecondary"
                                      position={"sticky"}
                                      onClick={() => {
                                        setIsFouced(false);

                                        if (
                                          element.trim() != editedData.trim()
                                        ) {
                                          setEditIndex(-1);
                                          setElement(element);
                                          setActions("edit");
                                          setField("designations");
                                          onOpen();
                                        }
                                      }}
                                    >
                                      Update
                                    </Button>
                                  )}
                                </Box>
                              ) : (
                                <Box flex="1" maxWidth="200px">
                                  {element}
                                </Box>
                              )}

                              {/* Icons */}
                              <Flex className="mr-2">
                                <img
                                  src={ButtonEdit}
                                  className="button-edit me-2 cursor-pointer"
                                  height={30}
                                  width={30}
                                  onClick={() => {
                                    handleClick(index, "designations");
                                    setIsFouced(!isFocused);
                                  }}
                                />
                                <img
                                  src={DeleteIcon}
                                  className="button-edit me-2 cursor-pointer"
                                  height={30}
                                  width={30}
                                  onClick={() => {
                                    setElement(element);
                                    setActions("delete");
                                    setField("designations");
                                    onOpen();
                                  }}
                                />
                              </Flex>
                            </ListItem>

                            <div className="border-1 mb-1 mt-1 border-b border-solid border-blue-300"></div>
                          </>
                        ))}
                      </UnorderedList>
                    </Box>
                  </Flex>
                </>
              ) : (
                <Center>
                  <tr>
                    <td
                      // colSpan={columns.length}
                      style={{ textAlign: "center" }}
                    >
                      <h2 className="m-4" style={{ fontSize: "30px" }}>
                        No Data!
                      </h2>
                    </td>
                  </tr>
                </Center>
              )}
            </>
          ) : (
            // ?main
            <div className="max-w-7xl p-10 pb-5 pe-20 ps-10">
              {
                <div className="flex max-h-96 w-full flex-col items-center justify-center border-4 border-dotted border-gray-500 bg-gray-300 dark:bg-gray-700">
                  <input
                    className="my-24 bg-gray-100 dark:bg-brandLinear"
                    type="file"
                    id="uploadFile"
                    name="file"
                    accept=".xls, .xlsx"
                    onFocus={() => setIsFouced(true)}
                    onBlur={() => setIsFouced(false)}
                    onChange={(e) =>
                      e.target.files[0] && setFile(e.target.files[0])
                    }
                  ></input>
                  <br />
                  <div className="my-8">
                    <Button
                      type="submit"
                      className="mx-5 rounded-md bg-brand-500 p-2 text-white dark:bg-brand-400"
                      onClick={() => {
                        submitFile();
                      }}
                    >
                      Upload File
                    </Button>
                    <Button
                      type="reset"
                      className="dark:bg-red mx-5 rounded-md bg-red-500 p-2 text-white"
                      onClick={() => {
                        setCsvModal(false);
                        loadData();
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              }
            </div>
          )}
        </Card>
      )}
      {isOpen && (
        <ChakraProvider>
          <Modal isCentered={true} isOpen={isOpen} onClose={onClose} size="xs">
            <ModalOverlay />
            <ModalContent className="dark:bg-blue-800">
              <ModalHeader textAlign={"center"} className="dark:text-white">
                {action == "addData" ? "Add Data" : action?.toUpperCase()}
              </ModalHeader>
              {/* <ModalCloseButton /> */}
              {/* <div className="mb-2 flex justify-center">
                <img src={DeleteIcon} />
              </div> */}
              <ModalBody className="text-center dark:text-white">
                {action == "delete" ? (
                  element
                ) : action == "edit" ? (
                  `${element} => ${editedData}`
                ) : (
                  <>
                    <Select
                      className="mb-2 mt-2 dark:bg-[#1d2955] dark:text-white"
                      placeholder="Select option"
                      onChange={(e) => {
                        setField(e.target.value);
                      }}
                    >
                      <option value="projects">Project</option>
                      <option value="designations">Designation</option>
                      <option value="departments">Department</option>
                    </Select>
                    <Input
                      className="dark:bg-[#1d2955] dark:text-white"
                      placeholder={`add ${field}`}
                      value={editedData}
                      // onBlur={() => {
                      //   setTimeout(() => {
                      //     setIsFouced(false);
                      //   }, 100);
                      // }}

                      onFocus={() => {
                        // setEditIndex(index);
                        // setIsFouced(true);
                      }}
                      onChange={(e) => handleInputChange(e.target.value)}
                      autoFocus // Focus input field on mount
                      // onBlur={() => setEditIndex(-1)} // Save edited project name on blur
                    />
                  </>
                )}
              </ModalBody>
              <div className="mt-3 flex justify-center gap-2">
                <Button
                  // style={{backgroundColor: 'red'}}
                  className="cancel-delete-modal-button dark:bg-red-500"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  className="delete-modal-button  bg-red-600"
                  style={{
                    backgroundColor: action == "delete" ? "red" : "#13BB35ff",
                  }}
                  onClick={() => {
                    if (action == "delete") {
                      updateData(field, element, action);
                    } else {
                      if (action == "addData") {
                        if (field == "") {
                          errorToast("Select Option!");
                          return;
                        } else if (!editedData) {
                          errorToast("Enter Data !");
                          return;
                        }
                      }
                      setEditIndex(-1);
                      updateData(field, element, action, editedData);
                    }
                  }}
                >
                  {action == "delete"
                    ? "Delete"
                    : action == "eidt"
                    ? "Update"
                    : "Add"}
                </Button>
                {action == "addData" && (
                  <Button
                    className="!text-m   !bg-blue-400 !pl-2 !pr-2"
                    onClick={() => {
                      onClose();
                      setCsvModal(true);
                    }}
                  >
                    Add Using Csv
                  </Button>
                )}
              </div>
              <ModalFooter></ModalFooter>
            </ModalContent>
          </Modal>
        </ChakraProvider>
      )}
    </>
  );
};
export default UserForm;
